import {Pipe, PipeTransform} from "@angular/core";
import {Language} from "../../shared/api/languages/api.models";

@Pipe({
    name: 'languages'
})

export class LanguagesPipe implements PipeTransform {
    transform(value: Language[], language: string, territory: string) {
        return value.filter((value: Language) => {

            if (language && (!value.language || value.language.indexOf(language) === -1)) {
                return false;
            }

            if (territory && (!value.territory || value.territory.indexOf(territory) === -1)) {
                return false;
            }

            return true;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/languages/languages.pipe.ts